export const localStorageClear = () => {
  localStorage.removeItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-period`)
  localStorage.removeItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-username`)
  localStorage.removeItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-clientid`)
  localStorage.removeItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-register-Questionnaires`)
  localStorage.removeItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-refresh`)
  localStorage.removeItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`)
}
